import { render, staticRenderFns } from "./InternalDossierForm.vue?vue&type=template&id=78c5f5d5"
import script from "./InternalDossierForm.vue?vue&type=script&lang=js"
export * from "./InternalDossierForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports